import { jsx as emotionCreateElement } from "@emotion/react";
import htmLiteral from "htm";

export const html = htmLiteral.bind(emotionCreateElement);
